import React, { useState } from 'react';
import './Footer.css';

function Footer() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Message sent successfully!');
    setFormData({ name: '', email: '', message: '' });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Contact Us</h3>
          <div className="contact-info">
            <p><span>📞</span> +94 11 234 5678</p>
            <p><span>📧</span> info@dreamvehicles.lk</p>
            <p><span>🕒</span> Mon-Sat: 9AM-6PM</p>
          </div>
        </div>

        <div className="footer-section">
          <h3>Location</h3>
          <div className="location-info">
            <p><span>📍</span> 123 Galle Road</p>
            <p>Colombo 03, Sri Lanka</p>
            <p>Near Liberty Plaza</p>
            <div className="map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3960.798467128!2d79.84731507570896!3d6.914744818433447!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae259684e2f8b93%3A0x8c3b1b8b1b8b1b8b!2sLiberty%20Plaza%2C%20Colombo!5e0!3m2!1sen!2slk!4v1234567890123!5m2!1sen!2slk"
                width="100%"
                height="150"
                style={{border: 0, borderRadius: '6px'}}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Muthugala Enterprises Location"
              ></iframe>
            </div>
          </div>
        </div>

        <div className="footer-section">
          <h3>Quick Contact</h3>
          <form onSubmit={handleSubmit} className="contact-form">
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <textarea
              name="message"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
            <button type="submit">Send Message</button>
          </form>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Dream Vehicles. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;